var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_wrapper"},[_c('Login',{staticClass:"login-container"}),_c('LoginIpad',{staticClass:"login-iPad-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }